module.exports = __webpack_public_path__ + "img/fbbz-home.f04e171a.png";